// extracted by mini-css-extract-plugin
export default {"zoomModal":"W5-z"};